// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const ExclamationPoint = createIcon(
  <path
    clipRule="evenodd"
    d="M12.9001 6.40196C12.9001 5.9049 12.4971 5.50195 12.0001 5.50195C11.503 5.50195 11.1001 5.9049 11.1001 6.40196V14.4021C11.1001 14.8991 11.503 15.3021 12.0001 15.3021C12.4971 15.3021 12.9001 14.8991 12.9001 14.4021V6.40196ZM12 19.9362C12.6904 19.9362 13.25 19.3766 13.25 18.6862C13.25 17.9958 12.6904 17.4362 12 17.4362C11.3096 17.4362 10.75 17.9958 10.75 18.6862C10.75 19.3766 11.3096 19.9362 12 19.9362Z"
    fillRule="evenodd"
  />,
);
